import { Outlet } from "react-router-dom";
import BackToMenuButton from "./BackToMenuButton";

export default function Layout() {
  return (
    <main data-testid="main-content">
      <Outlet />
      <BackToMenuButton />
    </main>
  );
}
